import styled from "styled-components";

// Toggle switch (trilho + knob) — visual único do Group Manager.
export const Switch = styled.label`
    position: relative; display: inline-block; width: 42px; height: 24px; flex: 0 0 auto;
    input { opacity: 0; width: 0; height: 0; }
    span { position: absolute; inset: 0; background: #CBD5E1; border-radius: 999px; transition: 0.2s; cursor: pointer; }
    span::before { content: ""; position: absolute; width: 18px; height: 18px; left: 3px; top: 3px; background: #FFF; border-radius: 50%; transition: 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.2); }
    input:checked + span { background: #22C55E; }
    input:checked + span::before { transform: translateX(18px); }
    input:disabled + span { opacity: 0.5; cursor: not-allowed; }
`;
